import styled from '@emotion/styled';
import { COLORS } from '../../constants';
import { Link } from '@reach/router';

export const StyledSideNavigationWrapper = styled.div`
  position: absolute !important;
  height: 100%;
  width: 100%;
  background: rgba(63, 63, 63, 0.7);
  top: 0;
  left: 0;
  z-index: 105;
`;

export const StyledSideNavigation = styled.div`
  position: absolute;
  background: ${COLORS.white};
  top: 0;
  bottom: 0;
  right: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 270px;
  background: ${COLORS.white};
  z-index: 31;
`;

export const StyledBottomMenu = styled.div`
  width: 100%;
  background-color: ${COLORS.seaBlue};
  color: ${COLORS.white};
`;

export const StyledBottomMenuButtons = styled.div`
  padding: 11px 23px !important;

  button {
    height: auto;
    margin: 4px 0px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5;
  }
`;

export const StyledAccountBlock = styled.div`
  display: flex;
  align-items: center;
  flew-wrap: nowrap;
  padding: 18px 5px 18px 38px;
  background-color: ${COLORS.seaBlue}!important;

  button {
    width: 28px;
    height: 28px;
    margin: 0px 11px 0px 0px;
    background: ${COLORS.white};
    border-color: ${COLORS.white};
    color: ${COLORS.seaBlue}!important;

    svg {
      width: 16.7px;
      height: 16.7px;
    }
  }
`;

export const StyledAccountBlockText = styled.p`
  font-size: 10px !important;
  font-weight: 300;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 160px;
  display: block;
  margin: 0;

  span {
    font-weight: 600;
  }
`;

export const StyledLink = styled(Link)`
  font-size: 10px !important;
  font-weight: 300;
  line-height: 1.5;
  margin: 0;

  span {
    font-weight: 600;
  }
`;
